export enum SkillResourceProvider {
  // Provider list on Staging as of 7/2/2025
  AMIRA = "amira",
  UFLI = "ufli",
  BAYOU_BRIDGES = "bayouBridges",
  KIDDOMEL = "kiddomel",
  KIDDOMEL_FOUNDATIONS = "kiddomelFoundations",
  BLUEBONNET = "bluebonnet",
  // TODO: Add other providers here
}